export default __webpack_public_path__ + "static/media/x-icon.14717a3b.svg";